import styled from 'styled-components';

export const StyledSelectButton = styled.div``;
